module.exports = __webpack_public_path__ + "img/imported_ordered_history_3.6990791c.png";